import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Box,
  Stack,
  Typography,
} from "@mui/material";

const FreeSignupNotValidFormPopup = ({ open, onCloseSignup, onCloseLogin }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === "backdropClick" && reason === "escapeKeyDown") {
          return;
        }
      }}
      aria-labelledby="customized-dialog-title"
      sx={{ borderRadius: "20px", background: "transparent" }}
    >
      <Stack
        sx={(theme) => ({
          background: theme.palette.common.black,
          borderTopLeftRadius: "20px",
          borderTopRightRadius: "20px",
        })}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {t("SignupCommonField.FreeSignup.Warning")}
        </DialogTitle>
      </Stack>
      <DialogContent
        sx={(theme) => ({
          background: theme.palette.background.cardGradient,
          border: 0,
          borderBottomLeftRadius: "20px",
          borderBottomRightRadius: "20px",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          alignItems: "center",
        })}
        dividers
      >
        <Typography sx={{}}>
          {t("SignupCommonField.FreeSignup.NotValidFormTitle")}
        </Typography>
        <Box width="100%">
          <Stack gap={"15px"} direction={{ xs: "column", sm: "row" }}>
            <Button
              fullWidth
              variant="outlined"
              color="secondary"
              onClick={onCloseSignup}
            >
              {t("Travertex.Signup")}
            </Button>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={onCloseLogin}
            >
              {t("Common.Login")}
            </Button>
          </Stack>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default FreeSignupNotValidFormPopup;
